<template>
  <div class="row settings-content">
    <div class="col-12">
      <!--begin::Portlet-->
      <div class="kt-portlet kt-portlet--bordered">
        <div class="kt-portlet__body">
          <!--begin::Accordion-->
          <div id="otherSettingsAccordion" class="accordion accordion-light  accordion-toggle-arrow">
            <div class="card">
              <div id="profile_picture_accordion_link" class="card-header">
                <div
                  class="card-title collapsed" data-toggle="collapse"
                  data-target="#profile_picture_accordion_content"
                  aria-expanded="false" aria-controls="profile_picture_accordion_content">
                  <i class="la la-photo" /> Profile Picture
                </div>
              </div>
              <div
                id="profile_picture_accordion_content" class="collapse"
                aria-labelledby="profile_picture_accordion_link"
                data-parent="#otherSettingsAccordion">
                <div class="card-body">
                  <profile-picture-uploader />
                </div>
              </div>
            </div>
            <div class="card">
              <div id="two_factor_accordion_link" class="card-header">
                <div
                  class="card-title collapsed" data-toggle="collapse"
                  data-target="#two_factor_accordion_content"
                  aria-expanded="false" aria-controls="two_factor_accordion_content">
                  <i class="flaticon2-chart" /> Two Factor Authentication
                </div>
              </div>
              <div
                id="two_factor_accordion_content" class="collapse"
                aria-labelledby="2fa_accordion_link"
                data-parent="#otherSettingsAccordion">
                <div class="card-body">
                  <two-factor-authentication />
                </div>
              </div>
            </div>

            <div v-if="user.is_admin && user.api_access" v-perms="[`api`]" class="card">
              <div id="api_access_accordion_link" class="card-header">
                <div
                  class="card-title collapsed" data-toggle="collapse"
                  data-target="#api_access_accordion_content"
                  aria-expanded="false" aria-controls="api_access_accordion_content">
                  <i class="la la-key" /> Api Access
                </div>
              </div>
              <div
                id="api_access_accordion_content" class="collapse"
                aria-labelledby="api_access_accordion_link"
                data-parent="#otherSettingsAccordion">
                <div class="card-body">
                  <personal-access-tokens />
                </div>
              </div>
            </div>

            <div v-if="tags_access" class="card">
              <div id="manage_tags_accordion_link" class="card-header">
                <div
                  class="card-title collapsed" data-toggle="collapse"
                  data-target="#manage_tags_accordion_content"
                  aria-expanded="false" aria-controls="manage_tags_accordion_content">
                  <i class="la la-tags" /> Manage Tags
                </div>
              </div>
              <div
                id="manage_tags_accordion_content" class="collapse"
                aria-labelledby="manage_tags_accordion_link"
                data-parent="#otherSettingsAccordion">
                <div class="card-body">
                  <tags />
                </div>
              </div>
            </div>

            <div v-perms="[`uploader_profiles`, `uploader-profiles.list`]" class="card">
              <div id="manage_uploader_profiles_accordion_link" class="card-header">
                <div
                  class="card-title collapsed" data-toggle="collapse"
                  data-target="#manage_uploader_profiles_accordion_content"
                  aria-expanded="false" aria-controls="manage_uploader_profiles_accordion_content">
                  <i class="flaticon2-user-1" /> Manage Uploader Profiles
                </div>
              </div>
              <div
                id="manage_uploader_profiles_accordion_content" class="collapse"
                aria-labelledby="manage_uploader_profiles_accordion_link"
                data-parent="#otherSettingsAccordion">
                <div class="card-body">
                  <uploader-profiles />
                </div>
              </div>
            </div>

            <div v-perms="[`customer_retention`]" class="card">
              <div id="manage_storage_retention_accordion_link" class="card-header">
                <div
                  class="card-title collapsed" data-toggle="collapse"
                  data-target="#manage_storage_retention_accordion_content"
                  aria-expanded="false" aria-controls="manage_storage_retention_accordion_content">
                  <i class="flaticon2-download" /> Manage Storage/{{ getItemLabel(true) }} Retention
                </div>
              </div>
              <div
                id="manage_storage_retention_accordion_content" class="collapse"
                aria-labelledby="manage_storage_retention_accordion_link"
                data-parent="#otherSettingsAccordion">
                <div class="card-body">
                  <customer-retention-table />
                </div>
              </div>
            </div>

            <div v-if="templates_access" class="card">
              <div id="manage_templates_accordion_link" class="card-header">
                <div
                  class="card-title collapsed" data-toggle="collapse"
                  data-target="#manage_templates_accordion_content"
                  aria-expanded="false" aria-controls="manage_templates_accordion_content">
                  <i class="la la-file-text" /> Manage Schedule Templates
                </div>
              </div>
              <div
                id="manage_templates_accordion_content" class="collapse"
                aria-labelledby="manage_templates_accordion_link"
                data-parent="#otherSettingsAccordion">
                <div class="card-body">
                  <templates-raw-table />
                </div>
              </div>
            </div>

            <div v-perms="['aiir']" class="card">
              <div id="aiir_accordion_link" class="card-header">
                <div
                  class="card-title collapsed" data-toggle="collapse"
                  data-target="#aiir_accordion_content"
                  aria-expanded="false" aria-controls="aiir_accordion_content">
                  <i class="la la-feed" /> Aiir
                </div>
              </div>
              <div
                id="aiir_accordion_content" class="collapse"
                aria-labelledby="aiir_accordion_link"
                data-parent="#otherSettingsAccordion">
                <div class="card-body">
                  <p>If you're a customer of our partner Aiir, you'll need to input a client ID below in their schedule settings. </p>

                  <p v-if="user.customer.aiir_client_id === null">
                    <span style="color: darkred"> You do not have a
                      <b>client_id</b> set. Please contact
                      <b>support@sharp-stream.com</b> for more information!
                    </span>
                  </p>
                  <p v-else>
                    Your Client ID: <b>{{ user.customer.aiir_client_id }}</b>
                  </p>

                  <p v-if="scheduler_publish_duration_epg === 0">
                    Your current publish duration is <b>forever</b>.
                    <span> To change it, use Defaults Configuration -> Scheduler Dafaults (for EPG / 3rd party) </span>
                  </p>
                  <p v-else>
                    Your current publish duration is: <b>{{ scheduler_publish_duration_epg }}</b> seconds.
                    <span> To change it, use Defaults Configuration -> Scheduler Defaults (for EPG / 3rd party) </span>
                  </p>
                </div>
              </div>
            </div>

            <div v-perms="['mixcloud']" class="card">
              <div id="mixcloud_accordion_link" class="card-header">
                <div
                  class="card-title collapsed" data-toggle="collapse"
                  data-target="#mixcloud_accordion_content"
                  aria-expanded="false" aria-controls="mixcloud_accordion_content">
                  <i class="socicon-mixcloud" /> Mixcloud
                </div>
              </div>
              <div
                id="mixcloud_accordion_content" class="collapse"
                aria-labelledby="mixcloud_accordion_link"
                data-parent="#otherSettingsAccordion">
                <div class="card-body">
                  <mixcloud-preferences />
                </div>
              </div>
            </div>

            <div class="card">
              <div id="default_config_accordion_link" class="card-header">
                <div
                  class="card-title collapsed" data-toggle="collapse"
                  data-target="#default_config_accordion_content"
                  aria-expanded="false" aria-controls="default_config_accordion_content">
                  <i class="la la-check-circle" /> Defaults Configuration
                </div>
              </div>
              <div
                id="default_config_accordion_content"
                class="collapse"
                aria-labelledby="default_config_accordion_link"
                data-parent="#otherSettingsAccordion">
                <div class="card-body">
                  <defaults />
                </div>
              </div>
            </div>
          </div>
          <!--end::Accordion-->
        </div>
      </div>
      <!--end::Portlet-->
    </div>
  </div>
</template>

<script>
import ProfilePictureUploader from "VuePartials/App/Preferences/ProfilePictureUploader";
import PersonalAccessTokens from "VuePartials/App/Passport/PersonalAccessTokens";
import Tags from "VuePartials/App/Preferences/Tags/Tags";
import TemplatesRawTable from "VuePartials/App/Preferences/TemplatesRawTable";
import Defaults from "VuePartials/App/Preferences/Defaults";
import TwoFactorAuthentication from "VuePartials/App/Preferences/TwoFactorAuthentication";
import UploaderProfiles from "VuePartials/App/ThirdPartyUploader/UploaderProfilesTable";
import CustomerRetentionTable from "VuePartials/App/CustomerRetention/CustomerRetentionTable";
import MixcloudPreferences from "VuePartials/App/Preferences/MixcloudPreferences";

export default {
  name: "Settings",
  components: {
    CustomerRetentionTable,
    ProfilePictureUploader,
    PersonalAccessTokens,
    Tags,
    TemplatesRawTable,
    TwoFactorAuthentication,
    Defaults,
    UploaderProfiles,
    MixcloudPreferences,
  },
  data: () => ({
    user: window.user,
    scheduler_publish_duration_epg: window.preferences.scheduler_publish_duration_epg,
  }),
  computed: {
    templates_access() {
      if (!this.permissionsCanAccessFeature('templates')) {
        return false;
      }
      return !!(this.permissionsCanDoAction(`api.templates.update`) || this.permissionsCanDoAction(`api.templates.destroy`));
    },
    tags_access() {
      return this.permissionsCanDoAction(`api.tags.index`);
    },
  },
  mounted() {
    // If there is a ?accordion_id param in the URL then open that accordion
    const accordion_param = location.search.match(new RegExp("[?&]accordion_id=([^&]+)(&|$)"));
    const accordion_id = accordion_param && decodeURIComponent(accordion_param[1].replace(/\+/g, " "));

    if (accordion_id) {
      // Clicking the accordion rather than adding a class will trigger all the other accordions to close
      // Leaving this the only one open.
      $(`#${accordion_id}`).find('.card-title').click();
      // Wait for the accordion to open.
      // Scroll to this section of the settings (ish).
      setTimeout(
        () => {
          $('html,body').animate({
            scrollTop: $(`#${accordion_id}`).offset().top,
          }, 1000);
        }, 1500);
    }
  },
};
</script>

<style scoped lang='scss'>
.settings-content {
    margin-top: 20px;
}

.portlet-title {
    margin-bottom: 20px;
}
</style>
